import { BoxProps } from "@mui/material";
import { useRef, useEffect, useState } from "react";
import { StyledCoverVideo } from "./VideoCover.styles";


type VideoCoverProps = BoxProps & {
  img?: string;
  loop?: boolean;
  onEnded?: () => void;
  url?: string;
};

export function VideoCover({
  img,
  loop = true,
  onEnded,
  url,
  ...props
}: VideoCoverProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  // Lazy loading: osserva quando il componente entra nel viewport
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
  }, []);

  // Gestione evento onEnded
  useEffect(() => {
    const video = videoRef.current;
    if (video && onEnded) {
      video.onended = onEnded;
    }
  }, [onEnded]);

  // Mostra immagine finché il video non è visibile e caricato
  return (
    <StyledCoverVideo
      ref={ containerRef }
      $image={ !isVisible || !isLoaded ? img : undefined }
      { ...props }
    >
      { isVisible && url ? (
        <video
          ref={ videoRef }
          autoPlay={ true }
          loop={ loop }
          muted={ true }
          src={ url }
          playsInline={ true }
          onLoadedData={ () => setIsLoaded(true) }
          style={ { display: isLoaded ? "block" : "none", height: "100%", width: "100%" } }
        />
      ) : null }
      { /* Mostra l'immagine come fallback se il video non è ancora caricato */ }
      { ((!isVisible || !isLoaded) && img) ? (
        <img
          src={ img }
          alt="cover"
          loading="lazy"
          style={ {
            borderRadius: String(props.borderRadius || "0.5rem"),
            height: "100%",
            left: 0,
            objectFit: "cover",
            position: "absolute",
            top: 0,
            width: "100%"
          } }
        />
      ) : null }
    </StyledCoverVideo>
  );
}
